"use client"
/* */
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';
import styles from '../../ListItemView.module.scss.mjs';
import '../../../../../../lib/propsContext/propsContext.mjs';
import '../../../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { dynamic } from '../../../../../../lib/propsContext/dynamicProps/dynamic.mjs';
import { PropsContextProvider } from '../../../../../../lib/propsContext/PropsContextProvider.mjs';
import clsx from 'clsx';
import { ColumnLayout } from '../../../../../ColumnLayout/ColumnLayout.mjs';

const getStyleForContentSlot = (slot) => slot === "top" ? styles.topContent : slot === "bottom" ? styles.bottomContent : styles.topContent;
const ListItemViewContent = (props) => {
  const {
    children,
    avatar,
    title,
    subTitle,
    button,
    bottom,
    checkbox,
    viewMode,
    s,
    m,
    l
  } = props;
  const contentProps = {
    bottom: {
      onMouseDown: (e) => e.stopPropagation(),
      onPointerDown: (e) => e.stopPropagation(),
      className: styles.bottomContent
    },
    top: {
      className: styles.topContent
    }
  };
  const propsContext = {
    ContextMenu: {
      placement: "bottom end"
    },
    Button: {
      className: styles.action
    },
    ActionGroup: {
      className: styles.action
    },
    Content: {
      className: dynamic((p) => getStyleForContentSlot(p.slot)),
      onMouseDown: dynamic((p) => contentProps[p.slot ?? "top"]?.onMouseDown),
      onPointerDown: dynamic(
        (p) => contentProps[p.slot ?? "top"]?.onPointerDown
      )
    },
    Avatar: {
      className: styles.avatar
    },
    Heading: {
      className: styles.heading,
      level: 5,
      Badge: { className: styles.badge },
      AlertBadge: { className: styles.badge }
    },
    Text: {
      className: styles.text
    },
    Link: {
      unstyled: true
    }
  };
  const className = clsx(
    styles.view,
    viewMode === "tiles" ? styles.tileView : styles.listView
  );
  const header = /* @__PURE__ */ jsxs("div", { className: styles.header, children: [
    /* @__PURE__ */ jsx("div", { className: styles.checkboxContainer, children: checkbox }),
    avatar,
    /* @__PURE__ */ jsxs("div", { className: styles.title, children: [
      title,
      /* @__PURE__ */ jsx("div", { className: styles.subTitle, children: subTitle })
    ] })
  ] });
  return /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, mergeInParentContext: true, children: /* @__PURE__ */ jsxs("div", { className, children: [
    viewMode === "list" && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: styles.contentWrapper, children: [
        s || m || l ? /* @__PURE__ */ jsxs(
          ColumnLayout,
          {
            s,
            m,
            l,
            className: clsx(styles.content, styles.columnLayout),
            mergeInParentContext: true,
            children: [
              header,
              children
            ]
          }
        ) : /* @__PURE__ */ jsxs("div", { className: styles.content, children: [
          header,
          children
        ] }),
        button
      ] }),
      bottom
    ] }),
    viewMode === "tiles" && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("div", { className: styles.avatarContainer, children: avatar }),
      /* @__PURE__ */ jsxs("div", { className: styles.content, children: [
        /* @__PURE__ */ jsxs("div", { className: styles.header, children: [
          /* @__PURE__ */ jsx("div", { className: styles.checkboxContainer, children: checkbox }),
          /* @__PURE__ */ jsxs("div", { className: styles.title, children: [
            title,
            /* @__PURE__ */ jsx("div", { className: styles.subTitle, children: subTitle })
          ] }),
          button
        ] }),
        children,
        bottom
      ] })
    ] })
  ] }) });
};

export { ListItemViewContent, ListItemViewContent as default };
//# sourceMappingURL=ListItemViewContent.mjs.map
